export default "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgIi9hc3NldHMvbG9nby5kMGM5ZmJlMy4zODAyOTQxMi0wOGVlLTQxZTEtOGUzNC0zYTJmZGFhNDk2OWIucG5nIjs="